import { DebtorCredentialResponse } from '../../contexts/DebtorAccountContext.types';
import { oktaGet } from '../oktaRequestWrapper';
import { ApiRoutes } from '../apiRoutes';

export const getDebtorCredentialAsync =
  async (): Promise<DebtorCredentialResponse> => {
    const response = await oktaGet<DebtorCredentialResponse>(
      ApiRoutes.DebtorCredential,
    );
    return response.data;
  };
